import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M15.696 11.053 9.948 6.06c-.376-.326-.891-.401-1.343-.195s-.734.644-.734 1.141v9.987c0 .498.281.935.734 1.141a1.245 1.245 0 0 0 1.343-.195l5.748-4.993a1.256 1.256 0 0 0 0-1.894z"
}), 'ArrowRight');